module.exports = __webpack_public_path__ + "img/tres_puntos.228946bc.svg";